"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SearchWithFilter_1 = __importDefault(require("@Components/Search/SearchWithFilter"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const Pagination_1 = __importDefault(require("@Components/Pagination"));
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const mobx_react_1 = require("mobx-react");
const react_sdk_1 = require("@openfeature/react-sdk");
const RightsholderAccountCard_1 = __importDefault(require("@Components/Cards/AccountCard/RightsholderAccountCard"));
const MemberInternalScene = () => {
    var _a;
    const { rightsholderSearchStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [preloaderIsOpen, setPreloaderIsOpen] = (0, react_1.useState)(false);
    const [searchValue, setSearchValue] = (0, react_1.useState)();
    const { value: showTestFlag } = (0, react_sdk_1.useFlag)('test-flag', false);
    const limitItems = 9;
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('home_internal');
        eventGetRightsHolders().then();
    }, [searchValue]);
    const eventGetRightsHolders = (callBackPagination) => __awaiter(void 0, void 0, void 0, function* () {
        let pagination = {
            page: 1,
            limit: limitItems,
        };
        if (callBackPagination) {
            pagination = Object.assign(Object.assign({}, pagination), callBackPagination);
        }
        try {
            setPreloaderIsOpen(true);
            yield rightsholderSearchStore.loadRightsholders(pagination, { query: searchValue });
        }
        catch (error) {
            popupStore.setAlertFromError(error);
        }
        finally {
            setPreloaderIsOpen(false);
        }
    });
    return (react_1.default.createElement("div", { className: 'home-internal-accounts-tab' },
        react_1.default.createElement("div", { className: "search-all-block" },
            react_1.default.createElement("p", null,
                rightsholderSearchStore.rightsholders && rightsholderSearchStore.rightsholders.totalElements,
                ' ',
                "Member accounts"),
            react_1.default.createElement(SearchWithFilter_1.default, { mainColor: true, id: 'publisher-search', onChangeInput: () => { }, value: '', placeholder: 'Search Members', withFilter: false, buttonClick: setSearchValue, onClearInput: () => setSearchValue('') })),
        react_1.default.createElement("div", { className: "accounts-block" },
            showTestFlag ? react_1.default.createElement("div", null, "Test flag is on") : null,
            preloaderIsOpen ? (react_1.default.createElement(PointPreloader_1.default, null)) : ((_a = rightsholderSearchStore.rightsholders) === null || _a === void 0 ? void 0 : _a.content.map((item, index) => (react_1.default.createElement(RightsholderAccountCard_1.default, { key: item.ipId ? item.ipId : index, rightsholderData: item })))),
            !preloaderIsOpen &&
                rightsholderSearchStore.rightsholders &&
                !rightsholderSearchStore.rightsholders.totalElements && (react_1.default.createElement("p", { className: 'small no-results' }, "No members"))),
        react_1.default.createElement(Pagination_1.default, { limit: limitItems, paginationPages: rightsholderSearchStore.paginationInfo, onChange: eventGetRightsHolders })));
};
exports.default = (0, mobx_react_1.observer)(MemberInternalScene);
